export enum sectionNameFontStyles {
  'xmall' = 'bodyBoldXS',
  'small' = 'bodyBoldSM',
  'medium' = 'bodyBoldMD',
}

export enum titleFontStyles {
  'xmall' = 'heading7',
  'small' = 'heading6',
  'medium' = 'heading5',
}

export enum contentFontStyles {
  'xmall' = 'bodyRegularSM',
  'small' = 'bodyRegularMD',
  'medium' = 'bodyRegularMD',
}
